@if (!showMissingVisual) {
<atx-image
  class="w-100 h-100"
  [imageUrl]="imageUrl"
  [failedLoadIconSize]="failedLoadIconSize"
  [maxWidth]="maxWidth"
  [fallbackImageUrl]="fallbackImageUrl"
  (imageLoaded)="onImageLoaded()"
  (imageError)="onImageError()"
></atx-image>
} @else {
<atx-product-image-missing-visual
  class="w-100 h-100"
  [product]="product"
  [svg]="productImageMissingVisualConfig?.svg"
  [replacementInstructions]="
    productImageMissingVisualConfig?.replacementInstructions
  "
></atx-product-image-missing-visual>
}
